import { render, staticRenderFns } from "./AnalysisCard.vue?vue&type=template&id=0bd2c4a5&scoped=true"
import script from "./AnalysisCard.vue?vue&type=script&lang=js"
export * from "./AnalysisCard.vue?vue&type=script&lang=js"
import style0 from "./AnalysisCard.vue?vue&type=style&index=0&id=0bd2c4a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd2c4a5",
  null
  
)

export default component.exports